import { useEffect, useState } from "react";
import CampaignList from "../Campaigns/reuseableComponents/campaignList";
import Lottie from "lottie-react";
import communityAnimation from "../../assets/animations/communityAnimation.json";
import closeIcon from "../../assets/icons/whiteClose.svg";

const SupportCampaign = ({setPageTitle}) => {
    useEffect(() => {
        setPageTitle("Campaigns");
        document.title="Support a campaign - Mosquepay"
      },[setPageTitle]);

      const [whatsappBanner, setWhatsappBanner] = useState(true);

      const closeWhatsappBanner = () => {
        setWhatsappBanner(false);
      };
  
    return (
      <div className="grid">
        {whatsappBanner && (
          <div className="p-4 md:p-6 rounded-md bg-black bg-whatsAppDoodle bg-[length:60%] text-white grid md:flex md:justify-between">
            <div className="order-2 md:order-1 w-full text-sm md:w-[70%]">
              <Lottie animationData={communityAnimation} loop={true} className="w-8"/>
              <div className="mt-4 mb-1">Join our whatsApp community!</div>
              <div className="text-secondary">Connect with like-minded individuals and stay updated on the latest Islamic fundraising campaigns. Be a part of a growing community dedicated to making a difference through Sadaqah and Zakat.</div>
            </div>
            <div className="text-white order-1 md:order-2 flex justify-end md:w-[30%]"><span onClick={closeWhatsappBanner} className="cursor-pointer"><img src={closeIcon} alt="" className="h-6" /></span></div>
          </div>
        )}
        <CampaignList
          cardLayout={"grid-cols-1 md:grid-cols-3"}
        />
      </div>
    );
}
 
export default SupportCampaign;